'use strict';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var elements = document.querySelectorAll('.population');
var values = _to_consumable_array(elements).reduce(function(prev, element) {
    prev.push(element.innerText);
    return prev;
}, []);
values = values.map(function(value) {
    var valueConvert = value.split(',').join('');
    return +valueConvert;
});
var total = values.reduce(function(prev, value) {
    return prev + value;
}, 0);
var average = Math.round(total / values.length);
var totalStyled = getNumberStyled(total);
var averageStyled = getNumberStyled(average);
document.querySelector('.total-population').innerText = totalStyled;
document.querySelector('.average-population').innerText = averageStyled;
function getNumberStyled(number) {
    if (!number) return;
    if (number < 1000) return String(number);
    var numberSeparated = String(number).split('').reverse();
    var finalNumber = '';
    var position = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = numberSeparated[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var num = _step.value;
            position++;
            finalNumber = num + finalNumber;
            if (position === 3) {
                position = 0;
                finalNumber = ',' + finalNumber;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (finalNumber[0] === ',') {
        finalNumber = finalNumber.split('');
        finalNumber.shift();
        finalNumber = finalNumber.join('');
    }
    return finalNumber;
}

//# sourceMappingURL=js_get_data_DOM.b08de63b.js.map
